module.exports = __webpack_public_path__ + "static/img/can-passionfruit.173a5b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-passionfruit.png
// module id = mgXM
// module chunks = 0